<template>
  <div class="flex-1 flex flex-col overflow-hidden">
    <Header :title="showLang[selectLang]['views']['Home']['page_name']" @childLang="useLang" @toggleSidebar="$emit('toggleSidebar')"/>
    <main class="flex-1 overflow-x-hidden overflow-y-auto" style="background: var(--ice);">
      <div class="d2-home-content">

        <!-- Card 1: 帳號連結 -->
        <div class="d2-card">
          <div class="d2-card-title"><i class="fas fa-link"></i>{{showLang[selectLang]['views']['Home']['page_name']}}</div>
          <LinkAccount v-bind:lang="showLang[selectLang]" v-bind:tiktokLang="showTiktokLangg[selectLang]" v-bind:firstLoginStatue="firstLoginStatue" v-bind:transmitFbNum="transmitFbNum" v-bind:transmitTiktokNum="transmitTiktokNum" v-bind:user_info="user_info" :guideStep="nowStep" @nextStep="nextStep" @closeTips="closeTips" @childOpenFirstLogin="openFirstLogin" @childChangeLinkType="setChangeLinkType" @adaccountLength="updateAdaccount" @pageLength="updatePage" @childActive="childActive"/>
        </div>
        <!-- Card 2: 方案資訊 (borderStyle==0 Facebook) -->
        <div v-if="borderStyle == 0 && (memberId != null && memberId != '')" class="d2-card">
          <div class="d2-card-title"><i class="fas fa-crown"></i>{{showLang[selectLang]['views']['Home']['plan_title'] || '方案資訊'}}</div>
          <Plan v-bind:plan="plans" v-bind:payList="payList" v-bind:userStatus="userStatus" v-bind:isExpired="is_expired" v-bind:connectionCard="connectionCard" v-bind:memberId="memberId" v-bind:usePlanId="usePlanId" v-bind:lang="showLang[selectLang]" v-bind:showPlans="showPlans" v-bind:transmitFbNum="transmitFbNum" v-bind:transmitTiktokNum="transmitTiktokNum" v-bind:source="source" v-bind:borderStyle="borderStyle" v-bind:useFbCustomize="useFbCustomize" :guideStep="nowStep" @canUseFbCustomize="canUseFbCustomize"/>
        </div>
        <!-- Card 2: 方案資訊 (borderStyle==1 TikTok) -->
        <div v-if="borderStyle == 1 && (tiktokMemberId != null && tiktokMemberId != '')" class="d2-card">
          <div class="d2-card-title"><i class="fas fa-crown"></i>{{showLang[selectLang]['views']['Home']['plan_title'] || '方案資訊'}}</div>
          <TikTokPlan v-bind:plan="tiktokPlans" v-bind:payList="payList" v-bind:userStatus="tiktokUserStatus" v-bind:isExpired="tiktokIsExpired" v-bind:connectionCard="tiktokConnectionCard" v-bind:memberId="tiktokMemberId" v-bind:usePlanId="tiktokUsePlanId" v-bind:lang="showLang[selectLang]" v-bind:showPlans="showPlans" v-bind:transmitFbNum="transmitFbNum" v-bind:transmitTiktokNum="transmitTiktokNum" v-bind:source="tiktokSource" v-bind:borderStyle="borderStyle" :guideStep="nowStep" />
        </div>
        <!-- Card 3: 分享管理 -->
        <div v-if="borderStyle == 0 && (memberId != null && memberId != '') && [142, 143, 3, 156].includes(Number(usePlanId))" class="d2-card">
          <div class="d2-card-title"><i class="fas fa-share-alt"></i>{{showLang[selectLang]['components']['Dialog']['SharingDialog']['title']}}</div>
          <p class="d2-card-desc">{{showLang[selectLang]['components']['Dialog']['SharingDialog']['card_desc'] || '邀請團隊成員共同管理廣告活動，分享帳號的活動額度資源。'}}</p>
          <button class="d2-btn d2-btn-outline" @click="showSharingDialog=true">
            <i class="fas fa-user-plus"></i> {{showLang[selectLang]['components']['Dialog']['SharingDialog']['manage_btn']}}
          </button>
        </div>
        <SharingDialog v-bind:lang="showLang[selectLang]" v-model:show="showSharingDialog" />
        <!-- Card 4: 加購活動 -->
        <div v-if="((borderStyle == 0 && memberId && payStatus == 'pay') || (borderStyle == 1 && tiktokMemberId && tiktokPayStatus == 'pay'))" class="d2-card">
          <div class="d2-card-title">
            <i class="fas fa-plus-square"></i>{{showLang[selectLang]['components']['Dialog']['AddonDialog']['title']}}
            <span v-if="addonCount > 0" class="d2-addon-status">
              {{showLang[selectLang]['components']['Dialog']['AddonDialog']['active_tag']}} (+{{ totalAddonNum }})
            </span>
          </div>
          <div class="d2-btn-row">
            <button class="d2-btn d2-btn-green" @click="showAddonDialog=true">
              <i class="fas fa-plus"></i> {{ addonCount > 0 ? showLang[selectLang]['components']['Dialog']['AddonDialog']['manage_btn'] : showLang[selectLang]['components']['Dialog']['AddonDialog']['purchase_now_btn'] }}
            </button>
          </div>
        </div>
        <AddonDialog v-bind:lang="showLang[selectLang]" v-model:show="showAddonDialog" @addonChanged="loadAddonCount" />
        <!-- Card 5: 個人資訊 (borderStyle==0 Facebook) -->
        <div v-if="borderStyle == 0 && (memberId != null && memberId != '')" class="d2-card" style="position:relative">
          <loading :active="!this.showMemberInfo"
                  :can-cancel="true"
                  :on-cancel="onCancel"
                  :is-full-page="false"
                  :color="'#fff'"
                  :background-color="'#000'"
                  :opacity="'0.8'"
                  :loader=" dots">
          </loading>
          <div class="d2-card-title">
            <i class="fas fa-user-circle"></i>{{showLang[selectLang]['views']['Home']['personal_information_text']}}
            <span v-if="isPay_emptyInvoice" style="font-size:12px; color:var(--slate); font-family:var(--font-body); font-weight:400;">{{showLang[selectLang]['views']['Home']['payment_information_text']}}</span>
          </div>
          <div class="d2-member-grid">
            <div class="d2-member-avatar">
              <img :src="img">
            </div>
            <div>
              <div class="d2-field-row">
                <span class="d2-field-label">{{showLang[selectLang]['views']['Home']['member_id_text']}}</span>
                <span class="d2-field-value">{{ account }}</span>
              </div>
              <div class="d2-field-row">
                <span class="d2-field-label">{{showLang[selectLang]['views']['Home']['member_name_text']}}</span>
                <span class="d2-field-value">{{ member_name }}</span>
              </div>
              <div>
                <div class="d2-field-row">
                  <span class="d2-field-label">{{showLang[selectLang]['views']['Home']['member_email_text']}}</span>
                  <span class="d2-field-value">
                    <span v-if="!isEditEmail">{{ email }}</span>
                    <i v-if="!isEditEmail" class="fas fa-pencil-alt d2-field-edit" @click="viewEdit('email')" v-tooltip="`${showLang[selectLang]['views']['Home']['member_phone_update_text']}`"></i>
                  </span>
                </div>
                <div v-if="isEditEmail" class="d2-inline-edit">
                  <input v-model="tmp_email" type="text" />
                  <button class="d2-btn-ghost" @click="isEditEmail=false">{{showLang[selectLang]['views']['Home']['member_phone_update_cancel_button_text']}}</button>
                  <button class="d2-btn d2-btn-yellow d2-btn-sm" @click="emailUpdate()">{{showLang[selectLang]['views']['Home']['member_phone_update_modify_button_text']}}</button>
                </div>
              </div>
              <div>
                <div class="d2-field-row">
                  <span class="d2-field-label">{{showLang[selectLang]['views']['Home']['member_phone_text']}}</span>
                  <span class="d2-field-value">
                    <span v-if="!isEdit">{{ phone }}</span>
                    <i v-if="!isEdit" class="fas fa-pencil-alt d2-field-edit" @click="viewEdit('phone')" v-tooltip="`${showLang[selectLang]['views']['Home']['member_phone_update_text']}`"></i>
                  </span>
                </div>
                <div v-if="isEdit" class="d2-inline-edit">
                  <input v-model="tmp_phone" type="text" />
                  <button class="d2-btn-ghost" @click="isEdit=false">{{showLang[selectLang]['views']['Home']['member_phone_update_cancel_button_text']}}</button>
                  <button class="d2-btn d2-btn-yellow d2-btn-sm" @click="phoneUpdate()">{{showLang[selectLang]['views']['Home']['member_phone_update_modify_button_text']}}</button>
                </div>
              </div>
              <div class="d2-field-row">
                <span class="d2-field-label">{{showLang[selectLang]['views']['Home']['payment_info_text']}}</span>
                <span class="d2-field-value">
                  <a href="javascript:void(0);" class="d2-field-link" @click="display=true">{{showLang[selectLang]['views']['Home']['payment_info_click_text']}}</a>
                </span>
              </div>
            </div>
          </div>
          <PaymentInfoDialog v-bind:lang="showLang[selectLang]" v-bind:invoices="invoices" v-bind:borderStyle="borderStyle" v-bind:memberId="memberId" v-model:show="display" @childIsPayEmptyInvoice="listenIsPayEmptyInvoice" />
        </div>

        <!-- Card 5: 個人資訊 (borderStyle==1 TikTok) -->
        <div v-if="borderStyle == 1 && (tiktokMemberId != null && tiktokMemberId != '')" class="d2-card" style="position:relative">
          <loading :active="!this.showMemberInfo"
                  :can-cancel="true"
                  :on-cancel="onCancel"
                  :is-full-page="false"
                  :color="'#fff'"
                  :background-color="'#000'"
                  :opacity="'0.8'"
                  :loader=" dots">
          </loading>
          <div class="d2-card-title">
            <i class="fas fa-user-circle"></i>{{showLang[selectLang]['views']['Home']['personal_information_text']}}
            <span v-if="tiktokIsPayEmptyInvoice" style="font-size:12px; color:var(--slate); font-family:var(--font-body); font-weight:400;">{{showLang[selectLang]['views']['Home']['payment_information_text']}}</span>
          </div>
          <div class="d2-member-grid">
            <div class="d2-member-avatar">
              <img :src="tiktokImg">
            </div>
            <div>
              <div class="d2-field-row">
                <span class="d2-field-label">{{showLang[selectLang]['views']['Home']['member_name_text']}}</span>
                <span class="d2-field-value">{{ tiktokMemberName }}</span>
              </div>
              <div>
                <div class="d2-field-row">
                  <span class="d2-field-label">{{showLang[selectLang]['views']['Home']['member_email_text']}}</span>
                  <span class="d2-field-value">
                    <span v-if="!isEditEmail">{{ tiktokEmail }}</span>
                    <i v-if="!isEditEmail" class="fas fa-pencil-alt d2-field-edit" @click="viewEdit('email')" v-tooltip="`${showLang[selectLang]['views']['Home']['member_phone_update_text']}`"></i>
                  </span>
                </div>
                <div v-if="isEditEmail" class="d2-inline-edit">
                  <input v-model="tiktokTmpEmail" type="text" />
                  <button class="d2-btn-ghost" @click="isEditEmail=false">{{showLang[selectLang]['views']['Home']['member_phone_update_cancel_button_text']}}</button>
                  <button class="d2-btn d2-btn-yellow d2-btn-sm" @click="emailUpdate()">{{showLang[selectLang]['views']['Home']['member_phone_update_modify_button_text']}}</button>
                </div>
              </div>
              <div>
                <div class="d2-field-row">
                  <span class="d2-field-label">{{showLang[selectLang]['views']['Home']['member_phone_text']}}</span>
                  <span class="d2-field-value">
                    <span v-if="!isEdit">{{ tiktokPhone }}</span>
                    <i v-if="!isEdit" class="fas fa-pencil-alt d2-field-edit" @click="viewEdit('phone')" v-tooltip="`${showLang[selectLang]['views']['Home']['member_phone_update_text']}`"></i>
                  </span>
                </div>
                <div v-if="isEdit" class="d2-inline-edit">
                  <input v-model="tiktokTmpPhone" type="text" />
                  <button class="d2-btn-ghost" @click="isEdit=false">{{showLang[selectLang]['views']['Home']['member_phone_update_cancel_button_text']}}</button>
                  <button class="d2-btn d2-btn-yellow d2-btn-sm" @click="phoneUpdate()">{{showLang[selectLang]['views']['Home']['member_phone_update_modify_button_text']}}</button>
                </div>
              </div>
              <div class="d2-field-row">
                <span class="d2-field-label">{{showLang[selectLang]['views']['Home']['payment_info_text']}}</span>
                <span class="d2-field-value">
                  <a href="javascript:void(0);" class="d2-field-link" @click="display=true">{{showLang[selectLang]['views']['Home']['payment_info_click_text']}}</a>
                </span>
              </div>
            </div>
          </div>
          <PaymentInfoDialog v-bind:lang="showLang[selectLang]" v-bind:invoices="tiktokInvoices" v-bind:borderStyle="borderStyle" v-bind:memberId="tiktokMemberId" v-model:show="display" @childIsPayEmptyInvoice="listenIsPayEmptyInvoice" />
        </div>

      </div>
    </main>
  </div>
  <Mask :isDisplay="nowStep > -1" />
  <PlanMask
    v-if="nowStep == 1"
    :nowStep="nowStep"
    :selectLang="selectLang"
    @nextStep="nextStep"
    @closeTips="closeTips"
  />
  <NotifyMask
    v-if="nowStep == 0"
    :nowStep="nowStep"
    :selectLang="selectLang"
    @nextStep="nextStep"
    @closeTips="closeTips"
  />
  <LinkAccountMask
    v-if="nowStep >= 2 && nowStep <= 7 ||  nowStep == 31"
    :nowStep="nowStep"
    :selectLang="selectLang"
    :topCode="topCode"
    @nextStep="nextStep"
    @closeTips="closeTips"
    @closeForTeaching="doCloseForTeaching"
  />
</template>

<script>
  // @ is an alias to /src
  import { createApp } from 'vue'
  import Mask from '@/components/Event/Mask.vue';
  import PlanMask from '@/components/Mask/PlanMask.vue';
  import LinkAccountMask from '@/components/Mask/LinkAccountMask.vue';
  import NotifyMask from '@/components/Mask/NotifyMask.vue';

  import Header from '@/components/Header.vue'
  import Plan from '@/components/Plan/Index.vue'
  import TikTokPlan from '@/components/TikTokPlan/Index.vue'
  import LinkAccount from '@/components/LinkAccount/Index.vue'
  import PaymentInfoDialog from '@/components/Dialog/PaymentInfoDialog.vue'
  import SharingDialog from '@/components/Dialog/SharingDialog.vue'
  import AddonDialog from '@/components/Dialog/AddonDialog.vue'
  import { API_BASE_URL } from '@/api/config'
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import axios from 'axios'
  import Qs from 'qs'
  import lang from '@/language/lang.json'
  import tiktokLang from '@/language/tiktok_lang.json'

  export default {
    name: 'Home',
    emits: ['toggleSidebar', 'childLang', 'nextStep', 'childHomeOpenFirstLogin', 'childSetChangeLinkType', 'canUseFbCustomize'],
    components: {
      Mask,
      PlanMask,
      LinkAccountMask,
      NotifyMask,
      Header,
      Plan,
      TikTokPlan,
      LinkAccount,
      PaymentInfoDialog,
      SharingDialog,
      AddonDialog,
      Loading
    },
    props: {
      newTeaching: {
        type: Boolean,
        default: false
      },
      getFirstLoginStatus: {
        type: Array
      },
      getTransmitFbNum: {
        type: String,
        default: ''
      },
      getTransmitTiktokNum: {
        type: String,
        default: ''
      },
      useFbCustomize: {
        type: Boolean,
      },
      closeForTeaching: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        selectLang: 'zh-TW',
        showLang: lang,
        showTiktokLangg: tiktokLang,
        nowStep: -1,
        topCode: null,
        isEdit: false,
        isEditEmail: false,
        display: false,
        showSharingDialog: false,
        showAddonDialog: false,
        addonCount: 0,
        totalAddonNum: 0,
        get_num: null,
        post_num: null,
        get_api_num: null,
        post_api_num: null,
        user_id: null,
        id: null,
        is_expired:null,
        account: null,
        member_name: null,
        email: null,
        tmp_email: null,
        phone: null,
        tmp_phone: null,
        img: null,
        showPlans: false,
        showMemberInfo: false,
        memberId: null,
        usePlanId: 1,
        connectionCard: false,
        isPay_emptyInvoice: false,
        adaccountData: 0,
        pageData: 0,
        firstLoginStatue: 'N',
        transmitFbNum: null,
        transmitTiktokNum: null,
        source: null,
        user_info:{
                user_id: null,
                tiktok_user_id: null,
        },
        plans:{
                expire_time:null,
                plan_title:null,
                plan_amount:null,
                plan_frequency:1,
                plan_description:null,
                plan_free:null,
                plan_a:null,
                plan_b:null,
                plan_c:null,
                plan_o:null,
                plan_d:null,
                plan_e:null,
                plan_f:null,
              },
        invoices:{
                  identifier:null,
                  name:null,
                  address:null,
                  mobile:null,
                  email:null,
                  card_no:null,
                },
        payList: null,
        userStatus: null,
        payStatus: null,
        tiktokPayStatus: null,
        tipsStatus: 'progress',
        borderStyle: 0,
        tiktokUserStatus:null,
        tiktokIsExpired:null,
        tiktokAccount: null,
        tiktokMemberName: null,
        tiktokEmail: null,
        tiktokTmpEmail: null,
        tiktokPhone: null,
        tiktokTmpPhone: null,
        tiktokImg: null,
        tiktokSource: null,
        tiktokMemberId: null,
        tiktokUsePlanId: 1,
        tiktokConnectionCard: false,
        tiktokIsPayEmptyInvoice: false,
        tiktokInvoices:{
          identifier:null,
          name:null,
          address:null,
          mobile:null,
          email:null,
          card_no:null,
        },
        tiktokPlans:{
          expire_time:null,
          plan_title:null,
          plan_amount:null,
          plan_description:null,
          plan_free:null,
          plan_a:null,
          plan_b:null,
          plan_c:null,
        },
      }
    },
    created() {
      let hash = this.$route.params.id;

      if(hash != '' && hash != null && typeof hash != 'undefined'){
         axios
          .post('https://www.autoturn.net/api/get_lang.php', Qs.stringify({
            s_code: this.$route.params.id
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.selectLang = response.data.return_data

              axios
                .post('https://www.autoturn.net/api/login.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  type: this.$route.params.type
                }), {withCredentials: true})
                .then((response) => {
                  if(response.data.status == 'success'){
                    // console.log('created:'+response.data.status);
                    // self.first_name = response.data.firstName;
                    // this.first_name = response.data.firstName
                    this.userStatus = response.data.userStatus;
                    this.payStatus = response.data.pay_status;
                    this.tiktokPayStatus = response.data.tiktok_pay_status;
                    this.is_expired = response.data.is_expired;
                    this.account = response.data.account;
                    this.member_name = response.data.name;
                    this.email = response.data.email;
                    this.tmp_email = response.data.email;
                    this.phone = response.data.phone;
                    this.tmp_phone = response.data.phone;
                    this.img = response.data.img;

                    this.showMemberInfo = true;

                    // 載入加購活動數（FB/IG 或 TikTok 付費中才載入）
                    if (response.data.pay_status == 'pay' || response.data.tiktok_pay_status == 'pay') {
                      this.loadAddonCount();
                    }

                    this.source = response.data.source;
                    this.memberId = response.data.id;
                    this.usePlanId = response.data.payment_plan_id;
                    this.connectionCard = response.data.connection_card;
                    this.isPay_emptyInvoice = response.data.isPay_emptyInvoice;

                    this.user_info = {
                      user_id: response.data.user_id,
                      tiktok_user_id: response.data.tiktok_user_id,
                    }

                    this.invoices = {
                      identifier : response.data.invoice_identifier,
                      name : response.data.invoice_name,
                      address : response.data.invoice_address,
                      mobile : response.data.invoice_mobile,
                      email : response.data.invoice_email,
                      card_no : response.data.card_no,
                    }

                    let description = [];
                    if(response.data.plan_description != '' && response.data.plan_description != null && typeof response.data.plan_description != 'undefined'){
                      let tmpDescription = JSON.parse(response.data.plan_description);
                      for(let i = 0; i < tmpDescription.length; i++){
                        description.push(tmpDescription[i]);
                      }
                    }

                    this.plans = {
                      expire_time : response.data.expire_time,
                      label_unit: response.data.label_unit,
                      plan_title : response.data.plan_title,
                      is_amount : response.data.is_amount,
                      plan_amount : response.data.plan_amount,
                      plan_frequency : response.data.plan_frequency || 1,
                      plan_description : description,
                      plan_free : response.data.plan_free,
                      plan_a : response.data.plan_a,
                      plan_b : response.data.plan_b,
                      plan_c : response.data.plan_c,
                      plan_d : response.data.plan_d,
                      plan_e : response.data.plan_e,
                      plan_f : response.data.plan_f,
                      plan_o : response.data.plan_o,
                    }

                    this.tiktokUserStatus = response.data.tiktok_userStatus;
                    this.tiktokIsExpired = response.data.tiktok_is_expired;
                    this.tiktokAccount = response.data.tiktok_account;
                    this.tiktokMemberName = response.data.tiktok_name;
                    this.tiktokEmail = response.data.tiktok_email;
                    this.tiktokTmpEmail = response.data.tiktok_email;
                    this.tiktokPhone = response.data.tiktok_phone;
                    this.tiktokTmpPhone = response.data.tiktok_phone;
                    this.tiktokImg = response.data.tiktok_img;

                    this.tiktokSource = response.data.tiktok_source;
                    this.tiktokMemberId = response.data.tiktok_id;
                    this.tiktokUsePlanId = response.data.tiktok_payment_plan_id;
                    this.tiktokConnectionCard = response.data.tiktok_connection_card;
                    this.tiktokIsPayEmptyInvoice = response.data.tiktok_isPay_emptyInvoice;

                    this.tiktokInvoices = {
                      identifier : response.data.tiktok_invoice_identifier,
                      name : response.data.tiktok_invoice_name,
                      address : response.data.tiktok_invoice_address,
                      mobile : response.data.tiktok_invoice_mobile,
                      email : response.data.tiktok_invoice_email,
                      card_no : response.data.tiktok_card_no,
                    }

                    let tiktokDescription = [];
                    if(response.data.tiktok_plan_description != '' && response.data.tiktok_plan_description != null && typeof response.data.tiktok_plan_description != 'undefined'){
                      let tiktokTmpDescription = JSON.parse(response.data.tiktok_plan_description);
                      for(let i = 0; i < tiktokTmpDescription.length; i++){
                        tiktokDescription.push(tiktokTmpDescription[i]);
                      }
                    }

                    this.tiktokPlans = {
                      expire_time : response.data.tiktok_expire_time,
                      label_unit: response.data.tiktok_label_unit,
                      plan_title : response.data.tiktok_plan_title,
                      is_amount : response.data.tiktok_is_amount,
                      plan_amount : response.data.tiktok_plan_amount,
                      plan_description : tiktokDescription,
                      plan_free : response.data.tiktok_plan_free,
                      plan_a : response.data.tiktok_plan_a,
                      plan_b : response.data.tiktok_plan_b,
                      plan_c : response.data.tiktok_plan_c,
                    }

                    // console.log(this.plans);

                    // let _type = 0;
                    // if((this.tiktokMemberId != '' && this.tiktokMemberId != null && typeof this.tiktokMemberId != 'undefined') && (this.memberId == '' || this.memberId == null || typeof this.memberId == 'undefined')){
                    //   _type = 1;
                    // }

                    // axios
                    //   .post('https://www.autoturn.net/api/payment_table.php', Qs.stringify({
                    //     s_code: this.$route.params.id,
                    //     type: _type
                    //   }))
                    //   .then((payResponse) => {
                    //     if(payResponse.data.status == 'success'){
                    //       this.payList = payResponse.data.return_data
                    //     }

                        this.showPlans = true;
                    //   });
                  }

                  if(response.data.status == 'error'){
                    // console.log('home logout');
                    // window.location.href = "https://ci.local/_autoturn_local_inside/index.php/login/view";
                    Swal.fire({
                      icon: 'error',
                      title: this.showLang[this.selectLang]['views']['Home']['axios']['login_error_title'],
                      text: response.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['Home']['axios']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        // this.allPageLoading = true
                        window.location.href = "https://www.autoturn.net/index.php/index/logout/"+hash+"?o=1";
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        // this.allPageLoading = true
                        window.location.href = "https://www.autoturn.net/index.php/index/logout/"+hash+"?o=1";
                      }
                    })
                  }

                  if(response.data.status == 'login'){
                    Swal.fire({
                      icon: 'error',
                      title: this.showLang[this.selectLang]['views']['Home']['axios']['login_error_title'],
                      text: response.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['Home']['axios']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        // this.allPageLoading = true
                        window.location.href = "https://www.autoturn.net/index.php/index/logout/"+hash+"?o=1";
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        // this.allPageLoading = true
                        window.location.href = "https://www.autoturn.net/index.php/index/logout/"+hash+"?o=1";
                      }
                    })
                  }
                });
            } else {
              Swal.fire({
                icon: 'error',
                title: this.showLang[this.selectLang]['views']['Home']['axios']['swal_title'],
                text: response.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['Home']['axios']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                }
              })
            }
          });

      } else {
        Swal.fire({
          icon: 'error',
          title: this.showLang[this.selectLang]['views']['Home']['axios']['login_empty_title'],
          text: this.showLang[this.selectLang]['views']['Home']['axios']['login_empty_info_text'],
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: this.showLang[this.selectLang]['views']['Home']['axios']['confirm_button']
          // denyButtonText: `Don't save`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            // Swal.fire('Saved!', '', 'success')
            // this.allPageLoading = true
            window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
          } else if (result.isDenied) {
            // Swal.fire('Changes are not saved', '', 'info')
            // this.allPageLoading = true
            window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
          }
        })
      }

    },
    watch:{
      'newTeaching': function(v){
        let tmpStatus = v.split('_');

        if(tmpStatus[0] == 'true'){
          this.nowStep = 0;
        }
      },
      'getFirstLoginStatus': function(v){
        if(v.data.return_data.first_login != '' && v.data.return_data.first_login != null && typeof v.data.return_data.first_login != undefined){
          this.firstLoginStatue = v.data.return_data.first_login;
        }
      },
      'getTransmitFbNum': function(v){
        //console.log('watch getTransmitFbNum');
        //console.log(v);
        //console.log(this.transmitFbNum);
        this.transmitFbNum = v;
        //console.log(this.transmitFbNum);
      },
      'getTransmitTiktokNum': function(v){
        //console.log('watch getTransmitTiktokNum');
        //console.log(v);
        //console.log(this.transmitTiktokNum);
        this.transmitTiktokNum = v;
        //console.log(this.transmitTiktokNum);
      },
      'closeForTeaching': function(v){
        //console.log('home closeForTeaching');
        //console.log(v);

        axios
          .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            status: 'N',
          }))
          .then((adResponse) => {
            this.nowStep = -1;
            this.firstLoginStatue = 'N';
          });
      },
    },
    methods: {
      loadAddonCount() {
        axios.post(`${API_BASE_URL}/addon_status.php`,
          Qs.stringify({ s_code: this.$route.params.id }),
          { withCredentials: true }
        ).then((response) => {
          let data = response.data;
          if (data.status == 'success') {
            this.addonCount = data.return_data.addon_count;
            this.totalAddonNum = data.return_data.addon_total_num;
          }
        }).catch(() => {});
      },
      viewEdit(type){
        if(type == 'email'){
          this.tmp_email = this.email
          this.isEditEmail = !this.isEditEmail
        }

        if(type == 'phone'){
          this.tmp_phone = this.phone
          this.isEdit = !this.isEdit
        }
      },
      emailUpdate(){
        let email = this.tmp_email

        if(this.borderStyle == 1){
          email = this.tiktokTmpEmail
        }

        axios
          .post('https://www.autoturn.net/api/data/email_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            form_data: email,
            type: this.borderStyle
          }))
          .then((response) => {
            // console.log(response.data);
            if(response.data.status == 'login'){
              Swal.fire({
                icon: 'error',
                title: this.showLang[this.selectLang]['views']['Home']['methods']['emailUpdate']['login']['swal_title'],
                text: response.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['Home']['methods']['emailUpdate']['login']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                }
              })
            } else {
              this.$swal(response.data.info);
              if(response.data.status == 'success'){
                this.email = email
              }
            }
            this.isEditEmail=false;
          });
      },
      useLang(v){
        if(v == '' || v == null || typeof v == 'undefined'){
          v = 'zh-TW';
        }

        this.selectLang = v
        this.$emit('childLang', v);

        document.title = this.showLang[this.selectLang]['views']['Home']['mounted']['page_name']+' - AutoTurn';
      },
      phoneUpdate(){
        let phone = this.tmp_phone

        axios
          .post('https://www.autoturn.net/api/data/phone_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            form_data: phone
          }))
          .then((response) => {
            // console.log(response.data);
            if(response.data.status == 'login'){
              Swal.fire({
                icon: 'error',
                title: this.showLang[this.selectLang]['views']['Home']['methods']['phoneUpdate']['login']['swal_title'],
                text: response.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['Home']['methods']['phoneUpdate']['login']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                }
              })
            } else {
              this.$swal(response.data.info);
              if(response.data.status == 'success'){
                this.phone = phone
              }
            }

            this.isEdit=false;
          });
      },
      listenIsPayEmptyInvoice(v){
        this.isPay_emptyInvoice = v
      },
      nextStep(v) {
        // console.log('v');
        // console.log(v);

        // NotifyMask (step 0) -> 跳到 LinkAccountMask (step 3)
        if(this.nowStep == 0){
          this.nowStep = 3;
          return;
        }

        axios
          .post('https://www.autoturn.net/api/member_info.php', Qs.stringify({
            s_code: this.$route.params.id,
          }), {withCredentials: true})
          .then((adResponse) => {
            // console.log('adResponse:'+adResponse.data.selecded_data);
            if(adResponse.data.status == 'success'){
              this.userName = adResponse.data.return_data.name
              this.userAccount = adResponse.data.return_data.account
              this.userImg =  adResponse.data.return_data.img

              if(adResponse.data.return_data.first_login == 'Y'){
                if(v != '' && v != null && typeof v != 'undefined'){
                  let returnDataTypeof = typeof v;
                  let returnData = -1;

                  // console.log('returnDataTypeof');
                  // console.log(returnDataTypeof);

                  if(returnDataTypeof == 'string'){
                    returnData = v.indexOf('act=');
                  }

                  if(returnData != -1 && this.nowStep == -1){
                    //服務條款
                    var todayForm = new Date();
                    var yearForm = todayForm.getFullYear();
                    var dateForm = String(todayForm.getDate()).padStart(2, '0');
                    var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                    var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                    todayForm = yearForm + monthForm + dateForm + timeForm;

                    this.topCode = 'true_'+v+'_'+todayForm;

                    //console.log('this.topCode');
                    //console.log(this.topCode);

                    var iHeight = 600;
                    var iWidth = 1000;
                    //获得窗口的垂直位置
                    var iTop = (window.screen.availHeight - 30 - iHeight) / 2;
                    //获得窗口的水平位置
                    var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
                    var windowStyle = 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,titlebar=no';

                    // let tosUrl = 'https://www.facebook.com/customaudiences/app/tos/?';
                    let tosUrl = 'https://business.facebook.com/ads/manage/customaudiences/tos/?';

                    var ch_window = window.open(tosUrl+v, '', windowStyle);

                    var timer = setInterval(function() {
                      console.log('warning ch_window:', ch_window);
                      if(ch_window.closed) {
                        clearInterval(timer);
                        // window.location.reload();
                      }
                    }, 1000);
                  } else if(v == 6 || v == 4){
                    if(this.tipsStatus == 'progress'){
                      this.nowStep = 7;
                    }
                  } else {
                    this.nowStep = this.nowStep + 1;
                  }
                } else if(v == 6 || v == 4){
                  if(this.tipsStatus == 'progress'){
                    this.nowStep = 7;
                  }
                } else if(typeof v == 'undefined' && (this.adaccountData == 0 || this.pageData == 0)){
                  this.nowStep = 31;
                } else {
                  this.nowStep = this.nowStep + 1;
                }
                // console.log('this.nextStep');
                // console.log(this.nowStep);

                if(this.nowStep == 7 && this.tipsStatus == 'progress'){
                  this.$emit('nextStep', this.nowStep);
                }
              } else {
                let returnData = -1;

                if(v != '' && v != null && typeof v != 'undefined'){
                   let returnDataTypeof = typeof v;

                   if(returnDataTypeof == 'string'){
                      returnData = v.indexOf('act=');
                    }
                }

                if(returnData != -1){
                  var iHeight = 600;
                  var iWidth = 1000;
                  //获得窗口的垂直位置
                  var iTop = (window.screen.availHeight - 30 - iHeight) / 2;
                  //获得窗口的水平位置
                  var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
                  var windowStyle = 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,titlebar=no';

                  // let tosUrl = 'https://www.facebook.com/customaudiences/app/tos/?';
                  let tosUrl = 'https://business.facebook.com/ads/manage/customaudiences/tos/?';

                  var ch_window = window.open(tosUrl+v, '', windowStyle);

                  var timer = setInterval(function() {
                    if(ch_window.closed) {
                      clearInterval(timer);
                      // window.location.reload();
                    }
                  }, 1000);
                }
              }


            } else {
              Swal.fire({
                icon: 'error',
                title: this.lang['components']['Sidebar']['error_title'] || '錯誤',
                text: adResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['Sidebar']['confirm_button'] || '確定'
              }).then((result) => {
                if (result.isConfirmed || result.isDenied) {
                  window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                }
              })
            }
          });        
      },
      closeTips(v) {
        this.nowStep = -1;

        if(v == 'notSmooth'){
          axios
          .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            status: 'N',
          }))
          .then((adResponse) => {
            this.firstLoginStatue = 'N';
          });
        }

        if(v == 'stageClose'){
          this.tipsStatus = 'stop';
        }
      },
      openFirstLogin(v){
        let tmpStatus = v.split('_');

        if(tmpStatus[0] == 'Y'){
          axios
          .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            status: 'Y',
          }))
          .then((adResponse) => {
            this.firstLoginStatue = 'Y';
          });
        }

        this.$emit('childHomeOpenFirstLogin', v);
      },
      setChangeLinkType(v){
        //console.log('setChangeLinkType');
        //console.log(v);
        this.$emit('childSetChangeLinkType', v);
      },
      updateAdaccount(v){
        this.adaccountData = v;
      },
      updatePage(v){
        this.pageData = v;
      },
      childActive(v){
        //console.log('childActive');
        //console.log(v);

        this.borderStyle = v

        axios
          .post('https://www.autoturn.net/api/payment_table.php', Qs.stringify({
            s_code: this.$route.params.id,
            type: v
          }))
          .then((payResponse) => {
            if(payResponse.data.status == 'success'){
              this.payList = payResponse.data.return_data
            }

            this.showPlans = true;
          });

        this.$emit('childBorderStyle', v);
      },
      canUseFbCustomize(v){
        //console.log('canUseFbCustomize', v);
        this.$emit('canUseFbCustomize', v);
      },
      doCloseForTeaching(){
        //console.log('home doCloseForTeaching');

        axios
          .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            status: 'N',
          }))
          .then((adResponse) => {
            this.nowStep = -1;
            this.firstLoginStatue = 'N';
          });
      }
    },
    mounted () {
      // document.title = '帳號資訊 - AutoTurn';

      // this.users = {
      //               first_name:'seedaaaa',
      //               second_name:'jasonsssss'
      //             };

      // this.invoices = {
      //                         identifier : 100,
      //                         name : 200,
      //                         address : 300,
      //                         mobile : 40,
      //                         email : 500,
      //                         card_no : 600,
      //                       }

      // axios
      //   .post('https://www.autoturn.net/api/login.php', Qs.stringify({
      //     s_code: this.$route.params.id
      //   }))
      //   .then((response) => {
      //     if(response.data.status == 'success'){
      //       console.log('mounted:'+response.data.status);
      //       // self.first_name = response.data.firstName;
      //       // this.first_name = response.data.firstName
      //       this.account = response.data.account;
      //       this.member_name = response.data.name;
      //       this.phone = response.data.phone;

      //       // this.invoices = {
      //       //                   identifier : response.data.invoice_identifier,
      //       //                   name : response.data.invoice_name,
      //       //                   address : response.data.invoice_address,
      //       //                   mobile : response.data.invoice_mobile,
      //       //                   email : response.data.invoice_email,
      //       //                   card_no : response.data.card_no,
      //       //                 }
      //     } else {
      //       window.location.href = "https://www.autoturn.net/index.php/login/view";
      //     }
      //   });

      ////////////////////////////////////////////

      // axios
      //   .get('https://www.autoturn.net/index.php/index/user_id')
      //   .then((response) => {
      //     console.log(response.data);
      //     console.log(response.data.user_id);
      //     // self.first_name = response.data.firstName;
      //     // this.first_name = response.data.firstName
      //     this.user_id = response.data.user_id;
      //   });

      // axios
      //   .get('https://www.autoturn.net/index.php/index/test_get/722')
      //   .then((response) => {
      //     console.log(response.data);
      //     console.log(response.data.age);
      //     // self.first_name = response.data.firstName;
      //     // this.first_name = response.data.firstName
      //     this.get_num = response.data.age;
      //   });

      // axios
      //   .post('https://www.autoturn.net/index.php/index/test_post', Qs.stringify({
      //     num: 723
      //   }))
      //   .then((response) => {
      //     console.log(response.data);
      //     console.log(response.data.age);
      //     // self.first_name = response.data.firstName;
      //     // this.first_name = response.data.firstName
      //     this.post_num = response.data.age;
      //   });

      // axios
      //   .get('https://www.autoturn.net/api/get_data.php?frist_name=lee&last_name=seed&age=1487')
      //   .then((response) => {
      //     console.log(response.data);
      //     console.log(response.data.age);
      //     // self.first_name = response.data.firstName;
      //     // this.first_name = response.data.firstName
      //     this.get_api_num = response.data.age;
      //   });

      // axios
      //   .post('https://www.autoturn.net/api/post_data.php', Qs.stringify({
      //     frist_name: 'lee',
      //     last_name: 'seed',
      //     age: 9487
      //   }))
      //   .then((response) => {
      //     console.log(response.data);
      //     console.log(response.data.age);
      //     // self.first_name = response.data.firstName;
      //     // this.first_name = response.data.firstName
      //     this.post_api_num = response.data.age;
      //   });
    },
    computed: {
      getFirstLoginStatusData: {
        get: function () {
          return this.getFirstLoginStatus
        },
        set: function (value) {
          this.$emit('update:getFirstLoginStatusData', value)
        },
      },
    }
    // mounted () {
    //   // this.$http = axios;
    //   // this.$http.jsonp('http://ci.local/index.php/welcome/test', {
    //   //   params: {},
    //   //   jsonp: 'handleCallback'
    //   // }).then((res) => {
    //   //   console.log(res);
    //   // });

    //   // axios.jsonp('http://ci.local/index.php/welcome/test').then(function (response) {
    //   //   console.log('then:'+response);
    //   // }).catch(function (error) {
    //   //   console.log('catch:'+error);
    //   // });

    //   // axios
    //   //   .get('https://www.runoob.com/try/ajax/json_demo.json')
    //   //   .then(response => (this.info = response))
    //   //   .catch(function (error) { // 请求失败处理
    //   //     console.log(error);
    //   //   });
    // }
  }
</script>

<style scope>
  .plan-free {
    width: 215px;
    height: 90px;
    background: rgb(127, 220, 250);
    background: linear-gradient(50deg, rgba(127, 220, 250, 1) 0%, rgba(47, 202, 189, 1) 100%);
  }
  .plan-a {
    width: 215px;
    height: 90px;
    background: rgb(127, 220, 250);
    background: linear-gradient(90deg, rgba(98,152,215,1) 0%, rgba(128,213,250,1) 100%);
  }
  .plan-b {
    width: 215px;
    height: 90px;
    background: rgb(127, 220, 250);
    background: linear-gradient(90deg, rgba(29,97,159,1) 0%, rgba(114,182,244,1) 100%);
  }
  .plan-c {
    width: 215px;
    height: 90px;
    background: rgb(127, 220, 250);
    background: linear-gradient(90deg, rgba(247,214,118,1) 0%, rgba(255,222,126,1) 100%);
  }
  .plan-d {
    width: 215px;
    height: 90px;
    background: rgb(127, 220, 250);
    background: linear-gradient(90deg, rgba(98,152,215,1) 0%, rgba(128,213,250,1) 100%);
  }
  .plan-e {
    width: 215px;
    height: 90px;
    background: rgb(127, 220, 250);
    background: linear-gradient(90deg, rgba(106,90,205,1) 0%, rgba(147,112,219,1) 100%);
  }
  .plan-o {
    width: 215px;
    height: 90px;
    background: rgb(127, 220, 250);
    background: linear-gradient(90deg, rgba(232,193,119,1) 0%, rgba(250,219,118,1) 100%);
  }

  .tiktok-plan-free {
    width: 215px;
    height: 90px;
    background: rgb(224, 224, 224);
    background: linear-gradient(50deg, rgba(33, 3, 24, 1) 0%, rgba(143, 143, 143, 1) 100%);
  }
  .tiktok-plan-a {
    width: 215px;
    height: 90px;
    background: rgb(224, 224, 224);
    background: linear-gradient(90deg, rgba(33, 3, 24,1) 0%, rgba(143, 143, 143,1) 100%);
  }
  .tiktok-plan-b {
    width: 215px;
    height: 90px;
    background: rgb(224, 224, 224);
    background: linear-gradient(90deg, rgba(33, 3, 24,1) 0%, rgba(143, 143, 143,1) 100%);
  }
  .tiktok-plan-c {
    width: 215px;
    height: 90px;
    background: rgb(224, 224, 224);
    background: linear-gradient(90deg, rgba(246, 14, 95,1) 0%, rgba(255, 129, 66,1) 100%);
  }

  @media (min-width: 768px) and (max-width: 1440px) {
    .plan-free, .plan-a, .plan-b, .plan-c, .plan-d, .plan-e, .plan-o, .tiktok-plan-free, .tiktok-plan-a, .tiktok-plan-b, .tiktok-plan-c {
      width: auto;
      height: 90px;
    }
  }

  @media (max-width: 767px) {
    .plan-free, .plan-a, .plan-b, .plan-c, .plan-d, .plan-e, .plan-o, .tiktok-plan-free, .tiktok-plan-a, .tiktok-plan-b, .tiktok-plan-c {
      width: auto;
      height: 50px;
    }
  }
</style>